
import QRCode from "qrcode";
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getShareInfo, getPromoteInfo } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
info: {}, //关于我们内容
share_url: "", //分享链接
img: '',
imgshow: false,
pinfo: {},
lang: 'de'
}
},
computed:{
...mapState(['token'])
},
created(){
this.lang = window.localStorage.getItem("lang") || 'de'
this.SETTOKEN()
this.getData()
this.getPromote()
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
getShareInfo({token: this.token,id: window.localStorage.getItem("uid")}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data
that.share_url =  `${location.origin}/#/pages/home/quotes?id=${that.info.rande}`
that.getQRCode()
}else if(res.status=='-1'){

}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
getPromote(){
var that = this
this.$Loading()
getPromoteInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.pinfo = res.data

}else if(res.status=='-1'){

}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
getQRCode() {
let opts = {
errorCorrectionLevel: "H",//容错级别
type: "image/png",//生成的二维码类型
quality: 0.3,//二维码质量
margin: 4,//二维码留白边距
width: 200,//宽
height: 200,//高
text:  this.share_url,//二维码内容
color: {
dark: "#333333",//前景色
light: "#fff"
}
};
this.QRCodeMsg = this.share_url; 
let msg = document.getElementById("QRcodeCanvas");    
QRCode.toCanvas(msg, this.QRCodeMsg, opts, function (error) {
console.log(error)
});    // 将canvas转成图片格式，可以长按保存
this.img = msg.toDataURL('image/png');
this.imgshow = true;
},
download(selector) {
const canvas = document.querySelector(selector);
const el = document.createElement('a');
el.href = canvas.toDataURL();
el.download = 'qrcode';
const event = new MouseEvent('click');
el.dispatchEvent(event);
},
share(val) {
if (!val) {
return
}
navigator.clipboard.writeText(val).then(() => {
this.sendMsg(this.$t('复制成功'));
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/shareQRcode.vue